// extracted by mini-css-extract-plugin
module.exports = {"leadershipHead":"Privacy_leadershipHead__3MvBN","section":"Privacy_section__3ZpJP","privacy":"Privacy_privacy__3Pq2H"};